<template>
  <div>
    <div class="content">
      <van-swipe :autoplay="3000" style="height: 200px;margin-top: 0px">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <div @click="linkCarouselDetail(image.id)" style="width: 100%;height: 100%">
            <van-image
                width="100%"
                height="100%"
                fit="fill"
                :src=image.imageUrl
            />
          </div>
        </van-swipe-item>
      </van-swipe>

      <div class="notice">
        <div>
          <van-notice-bar
              @click="showNotice"
              color="#0BCA92"
              background="#FFFFFF"
              :left-icon="laba"
              :scrollable="true"
              :text="notice"
          >
          </van-notice-bar>
        </div>
      </div>
<!--      <div style="height: 46px;width: 100%;">-->
<!--        <van-tabs v-model="header_active" @click="onClick">-->
<!--          <van-tab title="通勤巴士">-->
<!--          </van-tab>-->
<!--          <van-tab title="旅游巴士">-->
<!--          </van-tab>-->
<!--        </van-tabs>-->
<!--      </div>-->
      <div style="padding-top: 10px;width: 96%;padding-left: 2%;">
        <van-tabs sticky type="card" v-model="active" @click="onClick" title-active-color="#fff"
                  title-inactive-color="#0CC893" color="#0CC893">
          <van-tab title="今日票据">
            <div class="currentDate" v-if="showAll">{{ currentDate }}</div>
            <van-list v-if="showAll">
              <div v-for="item in toride.data" :key="item.id">
                <div class="card">
                  <div
                      style="border-bottom: 1px solid #ECECEC;display: flex;align-items: center;height: 45px;justify-content: space-between">
                    <span class="line"><img style="width: 14px;vertical-align: middle;padding-right: 5px;"
                                            :src="item.tickettype | getTicketToimg" alt=""><span
                        style="vertical-align: middle">{{ item.linename }}：{{ item.startname }} → {{ item.endname }}</span></span>
                    <span class="list-price">￥{{ item.ticketPrice }}</span>
                  </div>
                  <div style="display: flex;align-items: center;justify-content: space-between;height: 85px">
                    <div @click="linkBusDetail(item.busid)" style="width: 70%">
                      <div style="display: flex;height:35px;line-height: 35px">
                        <div style="width: 37%"><img :src="blueTime" width="13px" height="13px"><span
                            style="margin-left: 7px;margin-right: 13px">{{ item.starttime }}</span>
                        </div>
                        <div><img :src="placeUp" width="13px" height="13px"><span
                            style="margin-left: 7px;">{{ item.startname }}</span></div>
                      </div>
                      <div style="display: flex;height:35px;line-height: 35px">
                        <div style="width: 37%"><img :src="redTime" width="13px"
                                                     height="13px"><span
                            style="margin-left: 7px;margin-right: 13px">{{ item.endtime }}</span>
                        </div>
                        <div><img :src="placeDown" width="13px" height="13px"><span
                            style="margin-left: 7px;">{{ item.endname }}</span></div>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction: column;justify-content:space-around;height: 100%">
                      <van-button type="default" @click="checkTicket(item)" v-if="item.isCanCheck===1"
                                  :disabled="false"
                                  style="width:66px;height:28px;line-height:28px;background: #0CC893;color: #FFFFFF;border-radius: 5px">
                        验票
                      </van-button>
                      <van-button type="default" @click="refundTicket(item,today)" v-if="item.isCanRefund===1"
                                  :disabled="false"
                                  style="width:66px;height:28px;line-height:28px;background: #9E9E9E;color: #FFFFFF;border-radius: 5px">
                        退票
                      </van-button>
                      <van-button type="default" v-if="item.isCanCheck===0 && item.isCheck==1"
                                  :disabled="false"
                                  style="width:80px;height:28px;line-height:28px;background: #B0C4DE;color: #FFFFFF;border-radius: 5px">
                        已使用
                      </van-button>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
            <div style="text-align: center;margin: 12px 0px" v-if="toride.data&&toride.data.length <1">
              今日暂无可用票据
            </div>
            <div style="padding: 10px">
              <div>
                <van-icon name="warning" color="#F55456"/>
                注意:
              </div>
              <div class="notice" style="margin-bottom: 20px">
                <div>
                  1、发车前1小时内不能进行退票处理
                </div>
                <div>
                  2、已发车线路不能进行退票处理
                </div>
                <div>
                  3、请提前5分钟到乘车站点等车
                </div>
                <div>
                  4、每人每次能购买一张车票
                </div>
                <div>
                  5、如购买多张，需要多次购买
                </div>
                <div>
                  6、购买月票用户可以享受月票的价格优惠
                </div>
                <div>
                  7、因存在个别乘客上错车情况，上车后司机随时查票
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="待乘车">
            <van-list v-model="tripAllList.loading" :finished="tripAllList.finished" finished-text="没有更多了"
                      @load="onTorideLoadAll" style="margin-top: 15px">
              <van-collapse v-model="tripName" accordion @change="initTripAllList($event)">
                <van-collapse-item :title="item.date" :name="item.date"
                                   v-for="(item,index) in tripAllList.dateList" :key="index">
                  <van-row v-for="(line,indexNum) in tripAllList.data" :key="line.id"
                           style="margin-bottom: 10px;color: #5083ED;display: flex;align-items: center;">
                    <van-col span="16" style="color: #5083ED;font-size: 14px;font-weight: bold">
                      <div><img style="width: 14px;vertical-align: middle" :src="line.tickettype | getTicketToimg"
                                alt=""><span style="vertical-align: middle">{{ line.linename }}</span></div>
                      <div>{{ line.startname }} → {{ line.endname }}</div>
                    </van-col>
                    <van-col span="8" style="color: #0CC893;text-align: right;font-size: 14px">
                      <div>
                        <span>{{ line.state }}</span>
                        <span
                            style="background: #9E9E9E;color: #FFFFFF;padding: 5px 10px;border-radius: 5px;margin-left: 10px"
                            :disabled="refundBtnDisable(line,item.date)"
                            v-if="line.isCheck===0"
                            @click="refundTicket(line,item.date)">退票</span>
                      </div>
                    </van-col>
                  </van-row>
                </van-collapse-item>
              </van-collapse>
            </van-list>
          </van-tab>
          <van-tab title="退款订单">
            <van-list v-model="refund.loading" :finished="refund.finished" finished-text="没有更多了"
                      @load="onRefundLoad" style="margin-top: 15px">
              <van-collapse v-model="refundNum" accordion @change="initRefundData($event)">
                <van-collapse-item :title="item.date" :name="item.date"
                                   v-for="(item,index) in refund.dateList" :key="index">
                  <van-row v-for="(line,indexNum) in refund.data" :key="line.id"
                           style="margin-bottom: 10px;color: #202020;font-weight: bold">
                    <van-col span="18" style="color: #5083ED;font-size: 14px;font-weight: bold">
                      {{ line.linename }}：{{ line.startname }} → {{ line.endname }}
                    </van-col>
                    <van-col span="6" style="color: #5E5E5E;text-align: right">{{ line.state }}
                    </van-col>
                  </van-row>
                </van-collapse-item>
              </van-collapse>
            </van-list>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <div class="footer">
      <van-tabbar v-model="footerActive" active-color="rgb(12, 200, 147)" inactive-color="#FFFFFF"
                  style="background:#5083ED ">
        <van-tabbar-item :icon="car" to="/busIndex">预定巴士</van-tabbar-item>
        <van-tabbar-item :icon="scan" to="/ticketList">乘车验票</van-tabbar-item>
        <van-tabbar-item :icon="user" to="/user">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  Button,
  Tabs,
  Tab,
  List,
  Collapse,
  CollapseItem,
  Row,
  Col,
  Tabbar,
  TabbarItem,
  Image,
  Dialog,
  Swipe,
  SwipeItem,
  NoticeBar
} from 'vant';
import request from '../../utils/request'
import moment from 'moment'
import blueTime from './../../static/images/busTrip/blue_time.png'
import redTime from './../../static/images/busTrip/red_time.png'

import logo from './../../static/images/logo.png'
import laba from './../../static/images/laba.png'

import placeDown from './../../static/images/busTrip/placeDown.png'
import placeUp from './../../static/images/busTrip/placeUp.png'

import car from './../../static/images/busTrip/car.png'
import scan from './../../static/images/busTrip/scan.png'
import user from './../../static/images/busTrip/user.png'

import day from '@/static/images/busTrip/101598095025_.pic.jpg'
import month from '@/static/images/busTrip/131598095025_.pic.jpg'
import send from '@/static/images/busTrip/121598095025_.pic.jpg'
import integral from '@/static/images/busTrip/111598095025_.pic.jpg'

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [List.name]: List,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [NoticeBar.name]: NoticeBar,
  },
  data() {
    return {
      today: moment().format("YYYY-MM-DD"),
      placeDown: placeDown,
      placeUp: placeUp,
      car: car,
      scan: scan,
      user: user,
      tripName: '',
      notice: "",
      notice2: "",
      showAll: true,
      refundNum: '',
      activeName: '',
      currentDate: moment().format("YYYY年MM月DD日"),
      header_active: 0,
      active: 0,
      footerActive: 1,
      blueTime: blueTime,
      redTime: redTime,
      laba: laba,
      logo: logo,
      refund: {
        isOneHttp: true,
        loading: false,
        finished: false,
        data: [],
        dateList: [],
        pageSize: 20,
        pageNum: 1,
        total: 0
      },
      allOrder: {
        isOneHttp: true,
        loading: false,
        finished: false,
        dateList: [],
        data: [],
        pageSize: 20,
        pageNum: 1,
        total: 0
      },
      tripAllList: {
        isOneHttp: true,
        loading: false,
        finished: false,
        dateList: [],
        data: [],
        pageSize: 20,
        pageNum: 1,
        total: 0
      },
      toride: {
        data: [],
      },

    }
  },
  mounted() {
    this.initNotice();
    this.initAdvList();
  },
  methods: {
    //轮播详情
    linkCarouselDetail(val) {
      this.$router.push({path: '/carouselDetail', query: {id: val}})
    },

    showNotice() {
      let notice = this.notice2;

      Dialog.alert({
        title: '通知',
        confirmButtonText: '关闭',
        confirmButtonColor: '#0CC893',
        message: notice
      }).then(() => {
        // on close
      });
    },
    //广告位
    initAdvList() {
      //1-拼车 2-班车 3-班车验票
      let positionId = 2;
      request.sendGet({
        url: "/common/advertlist/" + positionId,
        params: {}
      }).then(res => {
        if (res.data.code == '0') {
          this.images = res.data.data;
        }
      })
    },

    //通知
    initNotice() {
      request.sendGet({
        url: "/common/notice/list",
        params: {}
      }).then(res => {
        if (res.data.code == '0') {
          let list = res.data.data;
          list.forEach(e => {
            this.notice += " ★ " + e.title + ' ★ ' + e.context + " ";
            this.notice2 += "<p> ★" + e.title + ' ★ </p><p>' + e.context + "</p>";
          });
        }
      })
    },
    //当天才能验票
    compareDate() {
      // let endTime =  new Date(date);
      // let startTime = new Date();
      // let days = moment(endTime).diff(moment(startTime), 'days');
      // if(days == '0'){
      //     return false;
      // }else {
      //     return true;
      // }
      return false;
    },

    checkTicket(item) {
      if (item.isCheck === 1) {
        this.$router.push({path: '/checkTicket', query: {'id': item.id}});
        return;
      }
      Dialog.confirm({
        title: '验票',
        message: '未到发车时间，验票后不可退票，确认是否验票？'
      }).then(() => {
        // 确定
        request.sendPost({
          url: "/bus/driverChecking",
          params: {
            isdriver: 0,
            checkcode: item.checkcode
          }
        }).then(res => {
          if (res.data.code == '0') {
            this.$toast.success("验票成功");
            this.$router.push({path: '/checkTicket', query: {'id': item.id}});
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
      }).catch(res => {
        console.error(res.toString())
      })
    },
    refundBtnDisable(item, ticketDay) {
      let end_date = moment(ticketDay + ' ' + item.starttime, "YYYY-MM-DD HH:mm");
      let start_date = moment(new Date(), "YYYY-MM-DD HH:mm");
      return end_date.diff(start_date, "hours") < 1 ? true : false;
    },
    refundTicket(item, ticketDay) {
      let end_date = moment(ticketDay + ' ' + item.starttime, "YYYY-MM-DD HH:mm");
      let start_date = moment(new Date(), "YYYY-MM-DD HH:mm");
      if (end_date.diff(start_date, "hours") < 1) {
        return;
      }
      Dialog.confirm({
        title: '退票',
        message: '请问是否退票？退票将收取您2元退票手续费（官方通知的特殊情况退票除外）。\n' +
            '请合理安排出行，感谢您的一路相伴。'
      }).then(() => {
        // 确定
        request.sendPost({
          url: '/bus/refundTicket',
          params: {
            ticketid: item.ticketid
          }
        }).then((res) => {
          if (res.data.code === 0) {
            this.$toast.success(res.data.msg);
            this.active = 2;
            this.onClick();
          } else {
            this.$toast.fail(res.data.msg);
          }
        })
      }).catch(res => {
        console.error(res.toString())
      });
    },

    onClick() {
      // this.tripAllList.data = [] ;
      this.tripName = '';
      this.refundNum = '';
      switch (this.active) {
        case 0:
          // if (this.showAll) {
          this.toride.isOneHttp = true;
          this.toride.loading = false;
          this.toride.finished = false;
          this.toride.data = [];
          this.toride.pageNum = 1;
          this.toride.total = 0;
          this.initTorideData();
          // }
          // else {
          //     this.tripAllList.isOneHttp = true;
          //     this.tripAllList.loading = false;
          //     this.tripAllList.finished = false;
          //     this.tripAllList.data = [];
          //     this.tripAllList.dateList = [];
          //     this.tripAllList.pageNum = 1;
          //     this.tripAllList.total = 0;
          //     this.initTripAllDateList();
          // }
          break;
        case 1:
          this.tripAllList.isOneHttp = true;
          this.tripAllList.loading = false;
          this.tripAllList.finished = false;
          this.tripAllList.data = [];
          this.tripAllList.dateList = [];
          this.tripAllList.pageNum = 1;
          this.tripAllList.total = 0;
          this.initTripAllDateList();
          // this.allOrder.isOneHttp = true;
          // this.allOrder.loading = false;
          // this.allOrder.finished = false;
          // this.allOrder.data = [];
          // this.allOrder.dateList = [];
          // this.allOrder.pageNum = 1;
          // this.allOrder.total = 0;
          // this.initAllOrderDateList();
          break;
        case 2:
          this.refund.isOneHttp = true;
          this.refund.loading = false;
          this.refund.finished = false;
          this.refund.data = [];
          this.refund.dateList = [];
          this.refund.pageNum = 1;
          this.refund.total = 0;
          this.initRefundDateList();
          break;
      }
    },

    initTripAllList(e) {
      request.sendPost({
        url: '/bus/checklist',
        params: {
          ischeck: 0,
          isrefund: 0,
          type: this.header_active === 0 ? '1' : '2',
          dateStr: e
        }
      }).then((res) => {
        this.tripAllList.data = res.data.rows;
      })
    },
    initTripAllDateList() {
      request.sendPost({
        url: '/bus/orderDateList',
        params: {
          ischeck: 0,
          isrefund: 0,
          type: this.header_active === 0 ? '1' : '2',
          pageNum: this.tripAllList.pageNum,
          pageSize: this.tripAllList.pageSize,
        }
      }).then((res) => {
        this.tripAllList.total = res.data.total;
        //判断是否是第一次请求数据
        if (this.tripAllList.isOneHttp) {
          this.tripAllList.dateList = res.data.rows;
          this.tripAllList.isOneHttp = false;
        } else {
          this.tripAllList.dateList = this.tripAllList.dateList.concat(res.data.rows);
        }

        if (this.tripAllList.total === this.tripAllList.dateList.length) {
          this.tripAllList.finished = true;
        }
        this.tripAllList.loading = false;
      })
    },
    onTorideLoadAll() {
      if (this.tripAllList.total > this.tripAllList.data.length) {
        this.tripAllList.pageNum += 1;
        this.initTripAllDateList();
      }
    },

    goAll() {
      this.showAll = false;
      this.tripAllList.isOneHttp = true;
      this.tripAllList.loading = false;
      this.tripAllList.finished = false;
      this.tripAllList.data = [];
      this.tripAllList.dateList = [];
      this.tripAllList.pageNum = 1;
      this.tripAllList.total = 0;
      this.initTripAllDateList();
    },
    onClickLeft() {
      this.$router.back(-1);
    },
    onRefundLoad() {
      if (this.refund.total > this.refund.dateList.length) {
        this.refund.pageNum += 1;
        this.initRefundDateList();
      }
    },
    initRefundData(e) {
      request.sendPost({
        url: '/bus/refundlist',
        params: {
          type: this.header_active === 0 ? '1' : '2',
          dateStr: e
        }
      }).then((res) => {
        this.refund.data = res.data.rows;
      })
    },
    initRefundDateList() {
      request.sendPost({
        url: '/bus/refundDateList',
        params: {
          type: this.header_active === 0 ? '1' : '2',
          pageNum: this.refund.pageNum,
          pageSize: this.refund.pageSize,
        }
      }).then((res) => {
        this.refund.total = res.data.total;
        //判断是否是第一次请求数据
        if (this.refund.isOneHttp) {
          this.refund.dateList = res.data.rows;
          this.refund.isOneHttp = false;
        } else {
          this.refund.dateList = this.refund.dateList.concat(res.data.rows);
        }

        if (this.refund.total === this.refund.dateList.length) {
          this.refund.finished = true;
        }
        this.refund.loading = false;

      })
    },
    onAllOrderLoad() {
      if (this.allOrder.total > this.allOrder.dateList.length) {
        this.allOrder.pageNum += 1;
        this.initAllOrderDateList();
      }
    },
    changeAllOrder(e) {
      request.sendPost({
        url: '/bus/checklist',
        params: {
          type: this.header_active === 0 ? '1' : '2',
          dateStr: e
        }
      }).then((res) => {
        this.allOrder.data = res.data.rows;
      });
    },
    initAllOrderDateList() {
      request.sendPost({
        url: '/bus/orderDateList',
        params: {
          type: this.header_active === 0 ? '1' : '2',
          pageNum: this.allOrder.pageNum,
          pageSize: this.allOrder.pageSize,
        }
      }).then((res) => {
        this.allOrder.total = res.data.total;
        //判断是否是第一次请求数据
        if (this.allOrder.isOneHttp) {
          this.allOrder.dateList = res.data.rows;
          this.allOrder.isOneHttp = false;
        } else {
          this.allOrder.dateList = this.allOrder.data.concat(res.data.rows);
        }

        if (this.allOrder.total === this.allOrder.dateList.length) {
          this.allOrder.finished = true;
        }
        this.allOrder.loading = false;
      })
    },
    initTorideData() {
      request.sendPost({
        url: '/bus/checklist',
        params: {
          type: this.header_active === 0 ? '1' : '2',
          dateStr: moment().format("YYYY-MM-DD"),
          ischeck: 0,
          isrefund: 0,
        }
      }).then((res) => {
        this.toride.data = res.data.rows;
      })
    },
    linkBusDetail(val) {
      this.$router.push({path: "/busDetail", query: {busid: val}})
    },
    getTicketToimg(type) {
      switch (type) {
        case 10:
          return day;
        case 20:
          return month;
        case 30:
          return integral;
        case 40:
          return send;
        default:
          return integral;
      }
    }
  },
  created() {
    this.initTorideData();
  },
  filters: {
    getTicketToimg(type) {
      switch (type) {
        case 10:
          return day;
        case 20:
          return month;
        case 30:
          return integral;
        case 40:
          return send;
        default:
          return integral;
      }
    }
  }
}
</script>

<style scoped>
/deep/ .van-tabs__line {
  background-color: #0CC893;
}

/deep/ .van-tabs__nav--card {
  margin: 0;
}

/deep/ .van-tab {
  color: #202020;
}

/deep/ .van-tab--active {
  color: #0CC893;
}

/deep/ .van-nav-bar .van-icon {
  color: #5E5E5E
}

.contain {
  background: #F6F6F6;
  overflow-x: hidden;
}

.currentDate {
  background-color: white;
  height: 37px;
  line-height: 37px;
  text-align: center;
  font-weight: bold;
  color: #202020;
  font-size: 18px;
  margin-top: 12px;
}

.card {
  font-size: 14px;
  padding: 0 5px;
  margin-top: 10px;
  background: #fff;
}

.line {
  color: #5083ED;
  font-size: 14px;
  font-weight: bold;
}

.list-price {
  font-weight: bold;
  font-size: 22px;
  color: #FF0200;
}

.footer {
  width: 100%;
}
</style>

<style>
.van-collapse-item__content {
  padding: 15px 10px;
}

.van-cell {
  padding: 10px;
}

.notice {
  background: #FFFFFF;
}

</style>
